@import "tailwindcss";

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  min-height: 100vh;
  transition: background 0.3s ease;
}

[data-theme="dark"] body {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
}

[data-theme="light"] body {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f8fafc 100%);
}

.glass {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

[data-theme="light"] .glass {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
}

.glass-card {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

[data-theme="light"] .glass-card {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.08);
}

.glass-card:hover {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  transform: translateY(-4px);
  box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.3);
}

[data-theme="light"] .glass-card:hover {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.12);
}

.glass-button {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.8), rgba(37, 99, 235, 0.8));
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px 0 rgba(59, 130, 246, 0.4);
  transition: all 0.3s ease;
}

[data-theme="light"] .glass-button {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.9), rgba(37, 99, 235, 0.9));
  border: 1px solid rgba(59, 130, 246, 0.3);
  box-shadow: 0 4px 15px 0 rgba(59, 130, 246, 0.3);
}

.glass-button:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 1), rgba(37, 99, 235, 1));
  box-shadow: 0 6px 20px 0 rgba(59, 130, 246, 0.6);
  transform: translateY(-2px);
}

.glass-input {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  transition: all 0.3s ease;
}

[data-theme="light"] .glass-input {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #1e293b;
}

.glass-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

[data-theme="light"] .glass-input::placeholder {
  color: rgba(0, 0, 0, 0.4);
}

.glass-input:focus {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.5);
  outline: none;
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.2);
}

[data-theme="light"] .glass-input:focus {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.15);
}

.gradient-text {
  background: linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.glow {
  box-shadow: 0 0 40px rgba(59, 130, 246, 0.3);
}

[data-theme="light"] .glow {
  box-shadow: 0 0 40px rgba(59, 130, 246, 0.2);
}

/* Theme-aware text colors */
.text-theme-primary {
  color: white;
  transition: color 0.3s ease;
}

[data-theme="light"] .text-theme-primary {
  color: #0a0a0a;
}

.text-theme-secondary {
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.3s ease;
}

[data-theme="light"] .text-theme-secondary {
  color: #1a1a1a;
}

.text-theme-tertiary {
  color: rgba(255, 255, 255, 0.5);
  transition: color 0.3s ease;
}

[data-theme="light"] .text-theme-tertiary {
  color: #333333;
}

.text-theme-muted {
  color: rgba(255, 255, 255, 0.4);
  transition: color 0.3s ease;
}

[data-theme="light"] .text-theme-muted {
  color: #666666;
}

/* Theme-aware borders */
.border-theme {
  border-color: rgba(255, 255, 255, 0.1);
  transition: border-color 0.3s ease;
}

[data-theme="light"] .border-theme {
  border-color: rgba(0, 0, 0, 0.1);
}

/* Section-specific backgrounds */
.bg-section-hero {
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.3) 0%, rgba(30, 41, 59, 0.2) 50%, rgba(15, 23, 42, 0.3) 100%);
}

[data-theme="light"] .bg-section-hero {
  background: linear-gradient(135deg, #f0f7fc 0%, #e6eff7 50%, #f0f7fc 100%);
}

.bg-section-features {
  background: linear-gradient(135deg, rgba(30, 20, 40, 0.25) 0%, rgba(40, 30, 50, 0.15) 50%, rgba(30, 20, 40, 0.25) 100%);
}

[data-theme="light"] .bg-section-features {
  background: linear-gradient(135deg, #f8f4fb 0%, #f0eaf5 50%, #f8f4fb 100%);
}

.bg-section-howitworks {
  background: linear-gradient(135deg, rgba(40, 35, 20, 0.25) 0%, rgba(50, 45, 30, 0.15) 50%, rgba(40, 35, 20, 0.25) 100%);
}

[data-theme="light"] .bg-section-howitworks {
  background: linear-gradient(135deg, #fcf9f0 0%, #f9f4e8 50%, #fcf9f0 100%);
}

.bg-section-pricing {
  background: linear-gradient(135deg, rgba(20, 40, 30, 0.25) 0%, rgba(30, 50, 40, 0.15) 50%, rgba(20, 40, 30, 0.25) 100%);
}

[data-theme="light"] .bg-section-pricing {
  background: linear-gradient(135deg, #f0fcf6 0%, #e6f9f0 50%, #f0fcf6 100%);
}

.bg-section-faq {
  background: linear-gradient(135deg, rgba(40, 25, 30, 0.25) 0%, rgba(50, 35, 40, 0.15) 50%, rgba(40, 25, 30, 0.25) 100%);
}

[data-theme="light"] .bg-section-faq {
  background: linear-gradient(135deg, #fcf4f5 0%, #f9eef0 50%, #fcf4f5 100%);
}

.bg-section-cta {
  background: linear-gradient(135deg, rgba(20, 30, 50, 0.25) 0%, rgba(30, 40, 60, 0.15) 50%, rgba(20, 30, 50, 0.25) 100%);
}

[data-theme="light"] .bg-section-cta {
  background: linear-gradient(135deg, #f0f4fc 0%, #e6eff9 50%, #f0f4fc 100%);
}

/* Animated SVG Background Animations */
@keyframes float-slow {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(30px, -30px) rotate(5deg);
  }
}

@keyframes float-medium {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(-20px, 20px) rotate(-5deg);
  }
}

@keyframes float-fast {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(25px, 15px) rotate(3deg);
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -200;
  }
}

.animate-float-slow {
  animation: float-slow 8s ease-in-out infinite;
}

.animate-float-medium {
  animation: float-medium 6s ease-in-out infinite;
}

.animate-float-fast {
  animation: float-fast 4s ease-in-out infinite;
}

.animate-dash {
  stroke-dasharray: 20 10;
  animation: dash 8s linear infinite;
}

.delay-100 {
  animation-delay: 100ms;
}

.delay-150 {
  animation-delay: 150ms;
}

.delay-200 {
  animation-delay: 200ms;
}

.delay-300 {
  animation-delay: 300ms;
}
